module.exports = __webpack_public_path__ + "static/media/Screenshot_5.584a18d5.png";